import React from 'react';
import { TextField } from '../../../../../../auth/TextField';
import {
  Form,
  Formik,
  ErrorMessage
} from 'formik';
import { Messages } from '../../../../../../../layout/Messages/Messages';
import { Button } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { CreateOrganizationGroupSchema } from '../../../../../../../../helpers/schemas';
import { NOTIFICATION_ADD_ADMIN_GROUP } from '../../../../../../../../config/notifications';
import { NOTIFICATION_ERROR } from '../../../../../../../../store/actions/types';

function GroupForm(props) {
    return (
      <Formik
        initialValues={{ groupName: ''}}
        validationSchema={ CreateOrganizationGroupSchema }
        validateOnChange={ false }
        onSubmit={async (values, { resetForm }) => {
          let reset = await props.onSubmit(values);

          if (reset) {
            resetForm({values: ''});
            if (values.action === 'save') {
              props.toggle();
            }
          }
        }}
      >
        { formikProps => {
          return (
            <Form>
              <div className="mx-2">
                <Messages notificationId={ NOTIFICATION_ADD_ADMIN_GROUP } />
                <Messages
                  color="danger"
                  notificationId="formValidation"
                  type={ NOTIFICATION_ERROR }
                  formikProps={ formikProps }
                >
                  <ErrorMessage
                    name="groupName"
                    component="div"
                    data-testid="errors-groupName"
                    className="field-error"
                  />
                </Messages>
              </div>
              <TextField
                name="groupName"
                handleBlur={ formikProps.handleBlur }
              />
              <div className="text-center text-sm-right py-3">
                <Button className="mt-2 mt-sm-0" name="add" type="submit" color="primary" onClick={() => formikProps.setFieldValue('action','add')}>
                  <FormattedMessage id="button.add" />
                </Button>
                <Button className="mt-2 mt-sm-0" name="save" type="submit" color="primary" onClick={() => formikProps.setFieldValue('action','save')}>
                  <FormattedMessage id="button.save" />
                </Button>
                <Button className="mt-2 mt-sm-0" color="secondary" onClick={ props.toggle }>
                  <FormattedMessage id="button.cancel"/>
                </Button>
            </div>
            </Form>
          )
        }}
      </Formik>
    )
}

export { GroupForm };
